import { useTranslation } from 'react-i18next';

import { AnimatedRoutedDrawer } from 'src/Components/Drawers/AnimatedRoutedDrawer';
import { MemoryForm } from 'src/Components/Forms/Memory/MemoryForm';
import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';

const CreateMemoryDrawer = () => {
  const { t } = useTranslation();
  const assetId = useCurrentAssetId();

  return (
    <AnimatedRoutedDrawer
      title={t('memories.drawer.createTitle', 'Nouveau souvenir')}
      to={`/asset/${assetId}/memories`}
    >
      {({ onClose }) => <MemoryForm onClose={onClose} />}
    </AnimatedRoutedDrawer>
  );
};

export default CreateMemoryDrawer;
